/**
 * Igual que backend/src/utils/superficiesFichaSplit.js
 * Separa plantas pegadas en «nombre» para la ficha (apartado Distribución).
 */

function norm(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

const RE_PLANTA = /\b(planta\s+(?:baja|bajo|primera|segunda|tercera|cuarta|quinta|sexta|s[eé]ptima|principal|arriba|\d+)|(?:primera|segunda|tercera|cuarta|quinta|sexta|s[eé]ptima)\s+planta|\d+\s*ª\s*planta|[aá]tico|s[oó]tano|entreplanta)\b/gi;

function etiquetaPlanta(label) {
  const n = norm(label);
  if (!n) return "";
  if (/planta\s+baja|^bajo$|planta\s+bajo/.test(n)) return "Planta baja";
  if (/primera/.test(n)) return "Primera planta";
  if (/segunda/.test(n)) return "Segunda planta";
  if (/tercera/.test(n)) return "Tercera planta";
  if (/cuarta/.test(n)) return "Cuarta planta";
  if (/quinta/.test(n)) return "Quinta planta";
  if (/sexta|septima/.test(n)) return n.includes("septima") ? "Séptima planta" : "Sexta planta";
  if (/atico/.test(n)) return "Ático";
  if (/sotano/.test(n)) return "Sótano";
  if (/entreplanta/.test(n)) return "Entreplanta";
  if (/arriba/.test(n)) return "Planta arriba";
  if (/principal/.test(n)) return "Planta principal";
  const num = n.match(/(\d+)/);
  if (num) return `Planta ${num[1]}`;
  return String(label || "").trim();
}

function trocear(texto) {
  const raw = String(texto || "").trim();
  if (!raw) return [];
  const hits = [...raw.matchAll(new RegExp(RE_PLANTA.source, "gi"))];
  if (!hits.length) return [{ nombre: "", observaciones: raw }];
  const out = [];
  if (hits[0].index > 0) {
    const lead = raw.slice(0, hits[0].index).replace(/[\s,;.\-–]+$/g, "").trim();
    if (lead) out.push({ nombre: "", observaciones: lead });
  }
  for (let i = 0; i < hits.length; i++) {
    const label = hits[i][1];
    const start = hits[i].index + label.length;
    const end = i + 1 < hits.length ? hits[i + 1].index : raw.length;
    const rest = raw.slice(start, end).replace(/^[\s,:;.\-–]+/, "").replace(/[\s,;.\-–]+$/g, "").trim();
    out.push({ nombre: etiquetaPlanta(label), observaciones: rest });
  }
  return out;
}

function esSoloEtiquetaPlanta(nombre) {
  const partes = trocear(nombre);
  return partes.length === 1 && !!partes[0].nombre && !partes[0].observaciones;
}

function fila(base, nombre, observaciones) {
  return {
    ...base,
    nombre: nombre || base.nombre || "",
    observaciones: observaciones || "",
    distribucion: observaciones || "",
  };
}

function separarFilaSuperficie(row) {
  if (!row || typeof row !== "object") return [];
  const nombre = String(row.nombre || row.tipo || "").trim();
  const obs = String(row.observaciones || row.distribucion || row.obs || "").trim();
  if (!nombre && !obs) return [];

  if (esSoloEtiquetaPlanta(nombre)) {
    const partesObs = trocear(obs);
    const plantasObs = partesObs.filter((p) => p.nombre);
    if (!plantasObs.length) return [fila(row, etiquetaPlanta(nombre) || nombre, obs)];
    const lead = partesObs[0] && !partesObs[0].nombre ? partesObs[0].observaciones : "";
    return [
      fila(row, etiquetaPlanta(nombre) || nombre, lead),
      ...plantasObs.map((p) => fila(row, p.nombre, p.observaciones)),
    ];
  }

  const combinado = [nombre, obs].filter(Boolean).join(", ");
  const partes = trocear(combinado);
  const plantas = partes.filter((p) => p.nombre);
  if (!plantas.length) return [fila(row, nombre, obs)];
  const lead = partes[0] && !partes[0].nombre ? partes[0].observaciones : "";
  return plantas.map((p, i) => {
    const extra = i === 0 && lead ? lead : "";
    const texto = [extra, p.observaciones].filter(Boolean).join(", ");
    return fila(row, p.nombre, texto);
  });
}

export function separarSuperficiesFicha(rows) {
  if (!Array.isArray(rows)) return [];
  const out = [];
  rows.forEach((row) => {
    separarFilaSuperficie(row).forEach((r) => {
      out.push({ ...r, orden: out.length });
    });
  });
  return out;
}
